import { memo, useMemo, useState, useContext, useEffect, useCallback, Fragment, useRef } from "react";
import { ReportContent, ReportHeader, ReportSearch } from "@/components/tableDrawer";
import "../requests/style.css";
import useNavs from "@/hooks/useNavs";
import { useSelectedTableItems } from "@/components/tableDrawer/reportContent/Hooks/useSelectedTableItems";
import { useTranslation } from "react-i18next";
import HospitalPopup from "@/components/popups/HospitalPopup/HospitalPopup";
import moment from "moment";
import { PATIENT_REQUEST_STATUS_MAP } from "@/data/status";
import Status from "../shared/RowsCells/Status/Status";
import TableHeader from "../shared/RowsCells/TableHeader";
import ActionBtn from "../shared/ActionBtn/ActionBtn";
import { DomainContext } from "@/context/DomainContext";
import { GetAMSubmittedOrders } from "@/api/endpoints";



const dateFormatter = (date) => {
  if(!date) return "--";
  return moment(date).format("YYYY-MM-DD HH:mm A");
}

const AccountManagerMedicalRequests = () => {
  const { t } = useTranslation();
  const hospitalRef = useRef(null);
  const { AccountManagerNav ,searchParams} = useNavs();
  const { setCustomSearchData } = useContext(DomainContext);
  const brokerId = searchParams.get("brokerId");
  const { selectedItems, handleSelected } = useSelectedTableItems();
  const [providerIds, setProviderIds] = useState([])


  
  useEffect(() => {
    if (brokerId) {
      setCustomSearchData(prev => ({ ...prev, BrokerId: brokerId }));
    }
    return () => {
      setCustomSearchData(prev => {
        const { BrokerId, ...rest } = prev;
        return rest;
      });
    };
  }, [brokerId, setCustomSearchData]);




  const viewRequestDetails = useCallback((original) => AccountManagerNav(`medical-reports/${original?.brokerPatientId}`), [AccountManagerNav]);
  // const viewQuotationDetails = useCallback((original) => AccountManagerNav(`medical-requests/${original?.brokerPatientId}/${original?.medicalOrderId}`), [AccountManagerNav]);
  const columns = useMemo(() => ([
      { Header: "ID", accessor: "brokerPatientId", canSearch: false, visible: true },
      { Header: "patientName", accessor: "patientName", canSearch: true, visible: true },
      { Header: "specialty", accessor: "specialty",canSearch: true, visible: true, Cell:({row:{original}})=>(<span className="specialty">{original?.category} <br /> <span className="sub-specialty">{original?.subCategory}</span></span>) },
      { Header: "brokerName", accessor: "brokerName", canSearch: true, visible: true },
      { Header: "request-date", accessor: "orderDate", type: "Date", canSearch: true, visible: true},
      { Header: "last-activity", accessor: "orderLastActivityAt", type: "Date", canSearch: false, visible: true ,
        Cell:({row:{original}})=>(
        <span className="last-activity">{dateFormatter(original?.orderLastActivityAt)}</span>
      )},
      {
        Header: "status",
        accessor: "StatusId",
        canSearch: true,
        visible: false,
        type: "DropDown",
        isMulti:false,
        options: PATIENT_REQUEST_STATUS_MAP,
        Cell: ({ row: { original } }) =>
          <Status status={{ name: t(original?.orderStatus), id: original?.orderStatusId }} />
        
      },
      {
        Header: "action",
        Cell: ({ row: { original } }) => (
         
            <ActionBtn
              isRender
              tooltipName={"patient-case-file"}
              onClick={() => viewRequestDetails(original)}
              reqAction="canGet"
              icon={"mdi:eye"}
            />
        ),
      },
    ]), [viewRequestDetails, t])



  return (
    <>
      <HospitalPopup hospitalRef={hospitalRef} providerIds={providerIds} setProviderIds={setProviderIds} selectedItems={selectedItems} />
      <TableHeader selectedItems={selectedItems} setProviderIds={setProviderIds} hospitalRef={hospitalRef} requests={true} />
      <ReportContent needCheckbox handleSelected={handleSelected} tableAPI={GetAMSubmittedOrders} columns={columns} stickyActions={true}>
        <ReportHeader title={"Medical Requests Pipeline"}>
          <ReportSearch />
        </ReportHeader>
      </ReportContent>
    </>
  );
};

export default memo(AccountManagerMedicalRequests);
